export default __webpack_public_path__ + "static/media/T1.1ce67d22.png";